import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-content',
  imports: [],
  templateUrl: './privacy-content.component.html',
  styleUrl: './privacy-content.component.css',
})
export class PrivacyContentComponent {

}
